export const AppBundle = {
  Journeys: 'journeys',
  DesignStudio: 'design-studio',
} as const;

export type AppBundle = (typeof AppBundle)[keyof typeof AppBundle];

export const AppBundleRoutes = {
  [AppBundle.Journeys]: '/journeys',
  [AppBundle.DesignStudio]: '/design-studio',
};

export const AppBundleNames = {
  [AppBundle.Journeys]: 'Journeys',
  [AppBundle.DesignStudio]: 'Design Studio',
};

declare global {
  interface Window {
    __hydra_preload_app_bundles__?: {
      [key in AppBundle]: Promise<unknown> | undefined;
    };
  }
}

export const registerPreloadPromise = (bundle: AppBundle, callback: () => Promise<unknown>) => {
  window.__hydra_preload_app_bundles__ ??= {
    [AppBundle.Journeys]: undefined,
    [AppBundle.DesignStudio]: undefined,
  };

  if (window.__hydra_preload_app_bundles__[bundle] != null) {
    return;
  }

  window.__hydra_preload_app_bundles__[bundle] = callback();
};

export const getEntrypoint = async (bundle: AppBundle) => {
  const preloadPromise = window.__hydra_preload_app_bundles__?.[bundle];
  if (preloadPromise == null) {
    return await window.importShim(bundle);
  }

  return await preloadPromise;
};
